// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"99bd4aeb938894b2","5763":"3a3271c8afcd0ba0","6893":"2304fb2dc34521eb","6974":"441284f2280a6f6f","7222":"366f4ef79f4a86d0","7937":"780bba09391c338c"}[chunkId] + ".js";
};